(function(){
  var box=document.querySelector('.shopify-policy__container'), rte=box&&box.querySelector('.shopify-policy__body .rte');
  if(!rte) return;
  function nice(t){
    t=t.replace(/&nbsp;/g,' ').replace(/\s+/g,' ').trim().replace(/[.:]$/,'');
    var m=t.match(/^SECTION\s+(\d+)\s*[-–]\s*(.*)$/i), n=m?m[1]:'', s=m?m[2]:t;
    var core=s.replace(/\(.*?\)/g,''), L=core.replace(/[^A-Za-z]/g,''), U=core.replace(/[^A-Z]/g,'');
    if(L.length&&U.length/L.length>.7){ s=s.toLowerCase(); s=s.charAt(0).toUpperCase()+s.slice(1); }
    return (n?'<span class="n">'+n+'.</span> ':'')+s;
  }
  var h=rte.innerHTML;
  if(!rte.querySelector('h2')){
    /* headings typed as bold lines become real headings */
    h=h.replace(/(<p[^>]*>|<br\s*\/?>)\s*<strong>([^<]{2,90})<\/strong>\s*(?:&nbsp;)?\s*(<br\s*\/?>|<\/p>)/gi,function(a,pre,t,post){
      return (/^<p/i.test(pre)?'':'</p>')+'<h2>'+nice(t)+'</h2>'+(/^<\/p/i.test(post)?'':'<p>');
    });
  }
  h=h.replace(/(?:&nbsp;)?\s*(<br\s*\/?>\s*)+/gi,'</p><p>');
  rte.innerHTML=h;
  [].forEach.call(rte.querySelectorAll('p'),function(p){ if(!p.textContent.replace(/ /g,'').trim()&&!p.querySelector('img,iframe')) p.remove(); });
  var first=rte.querySelector('p'); if(first&&/^last updated/i.test(first.textContent.trim())) first.className='cs-pol-date';
  var hs=rte.querySelectorAll('h2'); if(hs.length<3) return;
  var nav=document.createElement('nav'); nav.className='cs-pol-toc'; nav.setAttribute('aria-label','On this page');
  var ol=document.createElement('ol'); nav.innerHTML='<span>On this page</span>';
  [].forEach.call(hs,function(x,i){ x.id=x.id||'p-'+(i+1); var li=document.createElement('li'), a=document.createElement('a'); a.href='#'+x.id; a.textContent=x.textContent.replace(/^\d+\.\s*/,''); li.appendChild(a); ol.appendChild(li); });
  nav.appendChild(ol); box.insertBefore(nav, box.querySelector('.shopify-policy__body')); box.classList.add('has-toc');
  if('IntersectionObserver' in window){ var links=ol.querySelectorAll('a'); var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ [].forEach.call(links,function(l){ l.classList.toggle('on', l.getAttribute('href')==='#'+e.target.id); }); } }); },{rootMargin:'-20% 0px -70% 0px'}); [].forEach.call(hs,function(x){ io.observe(x); }); }
})();